import { Badge, Td, Tooltip, Tr } from "@chakra-ui/react"
import { Table, Tag } from "components"
import { Mask } from "config"

export default function Itens({ order, ...props }){
    const isPending = !!order.data?.parent_order_id
    return(
    <>
    <Table columns={[{ children: 'Produto' }, { children: 'Qtde', textAlign: 'center' }, { children: 'Qtde Atendida', textAlign: 'center' },{ children: isPending ? 'Valor Und. (ref.)' : 'Valor Und:', isNumeric: true }, { children: isPending ? 'Total (ref.)' : 'Total', isNumeric: true }]}>

        { order.data?.itens.map(item => !!item.product_kit ? <Kit item={item} order={order.data} isPending={isPending} /> : <Product item={item} order={order.data} isPending={isPending} />) }

        <Tr><Td colSpan={5} /></Tr>
        <Tr fontWeight="bold">
            <Td>Total de itens</Td>
            <Td isNumeric colSpan={4}>
                {isPending
                    ? <Tooltip label="Valor informativo. O pagamento ocorreu no pedido original."><Badge colorScheme="blue" mr={1}>ref.</Badge></Tooltip>
                    : null}
                R$ {Mask.price(isPending ? order.data?.itens?.reduce((acc, i) => acc + (i.display_amount ?? 0), 0) : order.data?.itens_amount)}
            </Td>
        </Tr>
    </Table>
    </>
    )
}

const RefBadge = () => (
    <Tooltip label="Valor informativo. O pagamento ocorreu no pedido original.">
        <Badge colorScheme="blue" mr={1} cursor="help">ref.</Badge>
    </Tooltip>
)

const Product = ({ item, order, isPending }) => {
    const displayPrice = isPending ? item.display_price_und : (item.price_und ?? item?.product?.distributor_price)
    const displayAmount = isPending ? item.display_amount : item.amount

    return(
    <Tr key={item.id}>
        <Td fontSize="xs">{item.product.name}</Td>
        <Td fontSize="xs" textAlign="center"><Tag colorScheme="orange" variant="solid">{item.quantity}</Tag></Td>
        <Td fontSize="xs" textAlign="center"><Tag colorScheme="orange" variant="solid">{item?.shipped_quantity ?? item.quantity}</Tag></Td>
        <Td fontSize="xs" isNumeric>
            {isPending
                ? <>{<RefBadge />}R$ {Mask.price(displayPrice)} {!!item.display_discount_percentage && <Badge size="sm" children={`- ${item.display_discount_percentage}%`} />}</>
                : !!order?.distributor_to_id
                    ? <>R$ {Mask.price(displayPrice)} <Badge size="sm" children={`- ${item?.discount_percentage ? item.discount_percentage : item?.product?.distributor_discount}%`} /></>
                    : <>R$ {Mask.price(item?.product?.consultant_price)} <Badge size="sm" children={`- ${item?.product?.wholesale_discount}%`} /></>
            }
        </Td>
        <Td fontSize="xs" isNumeric>
            {isPending && <RefBadge />}
            R$ {Mask.price(displayAmount)}
        </Td>
    </Tr>
)}

const Kit = ({ item, order, isPending }) => {
    const displayPrice = isPending ? item.display_price_und : (!!order?.distributor_to_id ? item.product_kit.price_distributor : item.product_kit.price_consultant)
    const displayAmount = isPending ? item.display_amount : item.amount

    return(
    <Tr key={item.id}>
        <Td fontSize="xs">{item.product_kit.label}</Td>
        <Td fontSize="xs" textAlign="center">{item.quantity}</Td>
        <Td fontSize="xs" textAlign="center"><Tag colorScheme="orange" variant="solid">{item?.shipped_quantity ?? item.quantity}</Tag></Td>
        <Td fontSize="xs" isNumeric>
            {isPending && <RefBadge />}
            R$ {Mask.price(displayPrice)}
        </Td>
        <Td fontSize="xs" isNumeric>
            {isPending && <RefBadge />}
            R$ {Mask.price(displayAmount)}
        </Td>
    </Tr>
)}
